import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './torneio_diegoftv00.module.scss';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5517988393564';

const TORNEIO_TITULO = '1º Torneio Diego Silva';

const LOCAL = 'TOP SOCCER';

const MAP_EMBED_SRC =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3726.4415405507566!2d-48.4660301!3d-20.9347763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bbe7d2869af629%3A0x8e7afd0be16bcd77!2sTop%20Soccer%20Bebedouro!5e0!3m2!1spt-BR!2sbr!4v1774641221216!5m2!1spt-BR!2sbr';

const INSCRICAO = 'Inscrição R$ 140 a dupla';

type CategoriaTorneio = {
    id: string;
    nome: string;
    data: string;
    premios: string[];
};

const CATEGORIAS: CategoriaTorneio[] = [
    {
        id: 'principiante',
        nome: 'Principiante',
        data: '09/05',
        premios: [
            '1º R$ 350 + troféu',
            '2º R$ 250 + troféu',
            '3º R$ 140 + troféu',
            '4º troféu',
        ],
    },
    {
        id: 'iniciante',
        nome: 'Iniciante',
        data: '09/05',
        premios: [
            '1º R$ 450 + troféu',
            '2º R$ 300 + troféu',
            '3º R$ 140 + troféu',
            '4º troféu',
        ],
    },
    {
        id: 'misto',
        nome: 'Misto Principiante',
        data: '10/05',
        premios: [
            '1º R$ 350 + troféu',
            '2º R$ 250 + troféu',
            '3º R$ 140 + troféu',
            '4º troféu',
        ],
    },
];

function buildWhatsAppUrl(categoria: CategoriaTorneio) {
    const msg =
        `Olá! Gostaria de me inscrever no ${TORNEIO_TITULO}. ` +
        `Categoria: ${categoria.nome} (${categoria.data}). ` +
        `${INSCRICAO}. ` +
        `Local: ${LOCAL}.`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

const Torneio_diegoftv00: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.torneio_diegoftv00}>
            <div className={styles.pageWrapper}>
                <div className={styles.inner}>
                    <div className={styles.header}>
                        <Link to="/diegoftv00" className={styles.backButton} aria-label="Voltar">
                            <FaArrowLeft />
                        </Link>
                        <h1 className={styles.title}>{TORNEIO_TITULO}</h1>
                    </div>

                    <div className={styles.hero}>
                        <img
                            className={styles.heroImg}
                            src={require('./src/torneio.png')}
                            alt={`Cartaz do ${TORNEIO_TITULO}`}
                            loading="lazy"
                        />
                    </div>

                    {CATEGORIAS.map((cat) => (
                        <div key={cat.id} className={styles.section}>
                            <div className={styles.sectionHeader}>
                                <h2 className={styles.sectionTitle}>{cat.nome}</h2>
                                <p className={styles.sectionInscricao}>Inscrição R$140,00 a dupla</p>
                            </div>
                            <p className={styles.sectionDate}>Data: {cat.data}</p>
                            <ul className={styles.premiosList}>
                                {cat.premios.map((linha, i) => (
                                    <li key={i}>{linha}</li>
                                ))}
                            </ul>
                            <a
                                href={buildWhatsAppUrl(cat)}
                                className={styles.cta}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                WhatsApp — {cat.nome}
                            </a>
                        </div>
                    ))}

                    <div className={styles.locationSection} aria-labelledby="local-torneio-heading">
                        <h2 id="local-torneio-heading" className={styles.locationHeading}>
                            Local do evento
                        </h2>
                        <div className={styles.mapEmbed}>
                            <iframe
                                src={MAP_EMBED_SRC}
                                title="Mapa: Top Soccer Bebedouro"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                allowFullScreen
                            />
                        </div>
                    </div>

                    <div className={styles.footer}>
                        <img
                            src={require('./src/logo.png')}
                            alt="DS"
                            className={styles.footerLogo}
                        />
                        <img
                            src={require('./src/logo_topsoccer.png')}
                            alt="Top Soccer"
                            className={styles.footerLogo}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Torneio_diegoftv00;
